import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.css';

const PopupJobDescriptionComponent = ({ 
    activeID , 
    jobListDetails, 
    showModalJob , 
}) => {
    

    const [jobDescription, setJobDescription] = useState(false);
    const [jobTitle, setJobTitle] = useState(false);
    const [showModal, setShowModalJobDetails] = useState(false);

    useEffect(() => {
        // fetchJobs();
        
        if(activeID !== false && jobListDetails.length > 0){
            setDestailJob(activeID);
            setShowModalJobDetails(!showModal)
        }
       
    }, [showModalJob]);

     const setDestailJob = async (id) =>{
        const foundItem = jobListDetails.find((item) => item.adId === id);
      
        if (foundItem) {
          
            setJobDescription(foundItem.description);
            setJobTitle(foundItem.title);
         } else {
          
        }
    } 


    return (
         
        <Modal  size="lg" className="jobDetails"  show={showModal} onHide={()=>setShowModalJobDetails(false)} >
            <Modal.Header closeButton>
            <Modal.Title>{jobTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body dangerouslySetInnerHTML={{__html : jobDescription}}></Modal.Body>
            <Modal.Footer>
            <Button className="apply-button" variant="secondary"  onClick={()=>setShowModalJobDetails(false)} >
                Close
            </Button>
        
            </Modal.Footer>
        </Modal>
    );
}
export default PopupJobDescriptionComponent;